module.exports = __webpack_public_path__ + "img/fondo_series.903aa184.svg";